import React, { FC, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import CONFIG_OPTIONS from "@app/constants/configOptions";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import useStyles from "./styles";
import StandardTemplate from "../Standard";
import { Divider } from "@mui/material";

const ConfigsTemplate: FC = () => {
  const [selectedOption, setSelectedOption] = useState(0);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const classes = useStyles();

  const handleClick = (index: number) => {
    if (!pathname.includes(CONFIG_OPTIONS[index].pathRoute)) {
      navigate(`/admin/configs${CONFIG_OPTIONS[index].pathRoute}`);
    }
    setSelectedOption(index);
  };

  return (
    <StandardTemplate>
      <Paper sx={classes.root} elevation={3}>
        <List component="nav" sx={classes.list}>
          {CONFIG_OPTIONS.map((configRoute, index) => (
            <ListItem
              button
              key={configRoute.name}
              selected={selectedOption === index}
              onClick={() => handleClick(index)}
            >
              <ListItemText primary={configRoute.name} />
            </ListItem>
          ))}
        </List>
        <Divider orientation="vertical" flexItem />
        <main style={classes.content}>
          <Outlet />
        </main>
      </Paper>
    </StandardTemplate>
  );
};

export default ConfigsTemplate;
